import {create} from 'zustand';
import { fetchClient } from '../api/services/Client';


// const apiUrl = process.env.REACT_APP_API_BASE_URL;
// const apiKey = process.env.REACT_APP_API_BASE_API_KEY;

export const useClientStore = create((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  clearFormData: () => set({ formData: {} }),
}));

export const fetchClientStore = create((set) => ({
  clientDetails: null,
  setClientDetails: (data) => set({ clientDetails: data }),
  fetchClientDetails: async (id) => {
    try {
      const data = await fetchClient(id);
      set({ clientDetails: data });
    } catch (error) {
      console.error('Error fetching client details:', error);
    }
  },
}));